import { render, staticRenderFns } from "./AllianceNews.vue?vue&type=template&id=43906a52&scoped=true"
import script from "./AllianceNews.vue?vue&type=script&lang=js"
export * from "./AllianceNews.vue?vue&type=script&lang=js"
import style0 from "./AllianceNews.vue?vue&type=style&index=0&id=43906a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43906a52",
  null
  
)

export default component.exports